import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'panel-filter-category',
    templateUrl: './panel-filter-category.component.html',
    styleUrls: ['./panel-filter-category.component.scss']
})
export class PanelFilterCategoryComponent {
    @Input()
    public heading: string;
}



// WEBPACK FOOTER //
// ./src/viega-common/components/collapsible-panel/panel-filter-category/panel-filter-category.component.ts